import React, { useEffect, useState } from "react";
import { ImageOverlay, MapContainer, Popup, TileLayer, Marker, Rectangle, Circle } from "react-leaflet";
import { Icon, CRS } from "leaflet";
import { Grid, Grow, Paper, Stack, Typography } from "@mui/material";
import "./Map.css";
import Box from "@mui/material/Box";
import WardPlacedMarker from "./map_icons/ward_placed";
import CampClearedMarker from "./map_icons/killed_camp";
import KillMarker from "./map_icons/kill";
import { HeatmapLayer } from "react-leaflet-heatmap-layer-v3/lib";

var summoners_rift = "https://static.wikia.nocookie.net/leagueoflegends/images/0/04/Summoner%27s_Rift_Minimap.png/revision/latest";

interface HeatmapDrawerParams {
    points: any[];
}
function renderSwitch(row: any) {
    switch (row["type"]) {
        case "WARD_PLACED":
            return WardPlacedMarker(row);
        case "KILLED_ANCIENT":
            return CampClearedMarker(row);
        case "KILL":
            return KillMarker(row);
        default:
            return WardPlacedMarker(row);
    }
}

function renderRectangle(row: any) {
    switch (row["type"]) {
        case "KILLED_ANCIENT":
            return (
                <Rectangle
                    bounds={[
                        [row["position"][1] * 750 - 22, row["position"][0] * 750 - 22],
                        [row["position"][1] * 750 + 22, row["position"][0] * 750 + 22],
                    ]}
                    color={row["side"]}
                ></Rectangle>
            );
        case "KILL_HITMAP":
            return <Circle center={[row["position"][1] * 750, row["position"][0] * 750]} radius={10} color={row["side"]}></Circle>;
        default:
            return <></>;
    }
}

export default function HeatMapDrawer(props: HeatmapDrawerParams) {
    let map_url = "../map tiles/0/0/0.png";

    const gradient = { 0.2: 'yellow', 0.4: 'orange', 0.6: 'red', 0.8: 'purple' }

    return (
        <Grow in={true} style={{ transformOrigin: "0 -50 0" }} {...{ timeout: 2000 }}>
            <Box
                sx={{
                    width: "900px",
                    height: "800px",
                    minWidth: "900px",
                    overflow: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                component="fieldset"
            >
                <MapContainer
                    center={[375, 375]}
                    scrollWheelZoom={false}
                    zoom={0}
                    dragging={false}
                    minZoom={0}
                    maxZoom={0}
                    attributionControl={false}
                    zoomControl={false}
                    doubleClickZoom={false}
                    crs={CRS.Simple}
                    bounds={[
                        [-0, -0],
                        [750, 750],
                    ]}
                >
                    <ImageOverlay
                        url={map_url}
                        bounds={[
                            [-0, -0],
                            [750, 750],
                        ]}
                        className={"heatmap-overlay"}
                    />
                    <HeatmapLayer
                        points={props.points.map((row: any) => [row.position[0] * 750, row.position[1] * 750, "test"])}
                        gradient={gradient}
                        intensityExtractor={(m: any) => 1}
                        longitudeExtractor={(m: any) => m[0]}
                        latitudeExtractor={(m: any) => m[1]}
                        radius={30}
                        blur={30}
                        max={1}
                        minOpacity={0.4}
                    />
                    {/*{rows.map(row => renderSwitch(row))}*/}
                </MapContainer>
            </Box>
        </Grow>
    );
}
